/**
 * Minimal mime → file-extension map for uploads we care about.
 * Replaces the full `mime-db` dataset for a single call site.
 */
const MIME_EXTENSIONS = {
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/rtf': 'rtf',
  'text/plain': 'txt',
  'text/csv': 'csv',
  'image/jpeg': 'jpeg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/heic': 'heic',
  'application/zip': 'zip',
}

/**
 * @param {string} mime
 * @returns {string} preferred file extension (no leading dot)
 */
export function extensionFromMime(mime) {
  const key = String(mime || '')
    .split(';')[0]
    .trim()
    .toLowerCase()
  if (MIME_EXTENSIONS[key]) return MIME_EXTENSIONS[key]

  const subtype = key.split('/')[1]
  if (!subtype) return 'bin'
  // e.g. image/svg+xml → svg
  const base = subtype.split('+')[0]
  if (base && !base.includes('.')) return base
  return 'bin'
}
